/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-04-26 17:36:39
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
   /**
   * getOpenapiList
   * @description 公司管理列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getOpenapiList(data) {
    return request.get(`${BASE_URL}/openapi/list`, data)
  },
  /**
   * saveCategory
   * @description 保存公司
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveOpenapi(data) {
    return request.post(`${BASE_URL}/openapi/store`, data)
  },
  /**
   * getCategoryInfo
   * @description 获取公司详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getOpenapiInfo(id) {
    return request.get(`${BASE_URL}/openapi/view/${id}`)
  },
  /**
   * deleteCategoryInfo
   * @description 删除公司
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteOpenapi(id) {
    return request.Delete(`${BASE_URL}/openapi/delete/${id}`)
  },
  /**
   * @description 分类排序
   * @author YM
   * @date 2019-03-07
   * @param {*} ids
   * @returns
   */
  orderOpenapi(ids) {
    let data = {ids:ids}
    return request.post(`${BASE_URL}/openapi/order`,data)
  },
  /**
   * @description 获取公司分类列表
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getOpenapiCategoryList() {
    return request.post(`${BASE_URL}/openapi/category_list`)
  },
}